var map = {
	"./archivo.svg": "81cb",
	"./doc.svg": "605b",
	"./escudo-XVII-Leg-blanco.svg": "3e99",
	"./escudo-XVII-Leg-gris.svg": "250c",
	"./jpg.svg": "155a",
	"./logo-uv-blanco.svg": "92b7",
	"./logo-uv-negro.svg": "b164",
	"./marca-de-verificacion.svg": "b15c",
	"./mp3.svg": "bc96",
	"./pdf.svg": "3f98",
	"./png.svg": "158b",
	"./subir.svg": "1c95",
	"./svg.svg": "3ec5",
	"./vector-fondo.svg": "8b73",
	"./verificacion.svg": "f437",
	"./xls.svg": "ca0b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "22d1";